import * as React from "react";
export class MiniEventCardPlaceholder extends React.PureComponent {
    constructor(props) {
        super(props);
        this.componentPrefix = "mini-ev-card-placeholder";
    }
    renderItems(eventsCount) {
        let elements = [];
        for (let i = 1; i <= eventsCount; i++) {
            elements.push(React.createElement("div", { key: `${this.componentPrefix}__item__${i}`, className: `rj-ev-list__${this.componentPrefix}__items-wrap` },
                React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}__player-info` },
                    React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}__player-names-wrap` },
                        React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}__player-name` }),
                        React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}__player-name` })),
                    React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}__icon` }))));
        }
        return elements;
    }
    render() {
        return (React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}` }, this.renderItems(this.props.eventsCount)));
    }
}
//# sourceMappingURL=MiniEventCardPlaceholder.js.map